<template>
  <div>
    <!-- <div class="handle_header">
        <el-card class="box-card">
          <div class="search">
            <el-form :inline="true">
              <el-form-item label="操作日期">
                <el-date-picker size="mini" value-format="yyyy-MM-dd" v-model="option.oper_date" type="date"
                  placeholder="请选择操作日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="供应商编码">
                <el-input size="mini" v-model="option.sup_no" placeholder="请输入供应商编码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" type="primary" @click="search">查询</el-button>
                <el-button size="mini" @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div> -->
    <div class="tableList">
      <el-button type="primary" size="mini" @click="derive">导出</el-button>
      <el-table :data="tableData" border style="width: 100%; margin-top: 10px"
        :row-style="{ 'font-size': '12px', color: '#324253' }"
        :header-row-style="{ 'font-size': '12px', color: '#8994A1' }">
        <el-table-column align="center" prop="name" label="使用者姓名"></el-table-column>
        <el-table-column align="center" prop="id_card" label="使用者身份证号码"></el-table-column>
        <el-table-column align="center" label="手机号">
          <template slot-scope="scope">
            <span @click="displayPhone(scope)">{{ scope.row.real_phone || scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="create_time" label="录入时间"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="deleteRow(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="tableData.length > 0"
        style="display: flex;justify-content: flex-end;"
        background
        @current-change="handleCurrentChange"
        :current-page="option.pageNum"
        :page-size="option.pageSize"
        :page-sizes="[10]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import axios from 'axios'
export default {
  name: "userList",
  data() {
    return {
      total: 0,
      option: {
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
    };
  },
  methods: {
    displayPhone(scope) {
      if (scope.row.real_phone) {
        return;
      }
      
      var password = prompt('请输入安全码');
      if (!password) {
          return;
      }

      axios({
        url: 'https://rz.hnbzyl.com/query_mobile',
        method: 'post',
        data: { id: scope.row.id, source: 1, password: password }
      }).then(res => {
        return res.data;
      }).then(res => {
          console.log('查询结果', res);
           if (!res || res.code != 200) {
              alert('查询失败');
              return;
          }
          scope.row.real_phone = res.data;
      }).catch(function(){
          alert('查询失败');
      });
  
    },
    deleteRow(scope) {
      console.log('删除', scope.row.id);
      var password = prompt('请输入安全码');
      if (!password) {
          return;
      }
  
      axios({
        url: 'https://rz.hnbzyl.com/delete_sign_row',
        method: 'post',
        data: { id: scope.row.id, password: password }
      }).then(res => {
        return res.data;
      }).then(res => {
          console.log('删除结果', res);
          if (!res || res.code != 200) {
              alert('删除失败');
              return;
          }
          this.tableData.splice(scope.$index, 1);
          alert('删除成功');
      }).catch(function(){
          alert('删除失败');
      });
    },
    derive() {
      
      var password = prompt('请输入安全码');
      if (!password) {
          return;
      }

      axios({
        url: 'https://rz.hnbzyl.com/download_xls',
        method: 'get',
        responseType: "blob",//重要配置
        params: { type: '用户注册', password: password, }
      }).then(res => {
        if (res.data.type == 'application/json') {
          alert('导出失败');
          return;
        }
        const aLink = document.createElement("a");
        let blob = new Blob([res.data])
        aLink.href = URL.createObjectURL(blob)
        aLink.setAttribute('download', '用户注册.xlsx') // 设置下载文件名称
        aLink.click()
      })
    },
    getList() {
      this.tableData = [];
      axios({
        url: `https://rz.hnbzyl.com/list_user_registration`,
        method: 'get',
        params: this.option
      }).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      })
    },
    handleCurrentChange(val, currentPage) {
      this.option.pageNum = val;
      this.getList();
    },
    search() {

    },
    reset() {

    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.page {
  text-align: right;
}
</style>